// src/components/rpa/agent/AgentApprovalCard.js
import React from 'react';
import './AgentApprovalCard.css';

const AgentApprovalCard = ({ plan, onApprove, onCancel, loading }) => {
  return (
    <div className="agent-approval-card">
      <div className="approval-header">
        <span className="approval-icon">⚠️</span>
        <span className="approval-title">Approval Required</span>
      </div>

      <div className="approval-body">
        <div className="approval-row">
          <span className="approval-label">Document</span>
          <span className="approval-value">{plan.docName}</span>
        </div>
        <div className="approval-row">
          <span className="approval-label">Workflow</span>
          <span className="approval-value">{plan.workflow}</span>
        </div>
        <div className="approval-row">
          <span className="approval-label">Step</span>
          <span className="approval-value step-badge">{plan.stepTitle || plan.stepId}</span>
        </div>
        <div className="approval-row">
          <span className="approval-label">Action</span>
          <span className="approval-value">{plan.description}</span>
        </div>
      </div>

      <p className="approval-question">
        Do you want me to run <strong>{plan.description}</strong> now?
      </p>

      <div className="approval-actions">
        <button
          className="approval-btn approve"
          onClick={onApprove}
          disabled={loading}
        >
          {loading ? 'Running…' : '✓ Yes, run it'}
        </button>
        <button
          className="approval-btn cancel"
          onClick={onCancel}
          disabled={loading}
        >
          ✕ Cancel
        </button>
      </div>
    </div>
  );
};

export default AgentApprovalCard;